import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Menu, X } from 'react-feather';
import { Avatar, IconButton } from '../';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import headerLogo from './HeaderLogo.svg';

export const useHeaderClasses = makeStyles({
    root: {
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 5px',
        borderBottom: `1px solid ${theme.colors.green[4]}`,
        background: theme.colors.darkBlue[1],
        color: theme.colors.white,
        ...theme.typography.content.label.default,
        '& > hr': {
            height: 35,
            background: theme.colors.darkBlue[2],
        },
    },
    logo: {
        marginLeft: 30,
    },
    avatar: {
        marginRight: 15,
    },
});

/**
 * Global header component.
 */
export const Header = () => {
    const classes = useHeaderClasses();
    const dispatch = useTypedDispatch();
    const sidebar = useTypedSelector(state => state.global_sidebar);

    return (
        <header className={classes.root}>
            <IconButton onClick={() => dispatch(actions.global_sidebar.toggle())}>
                {sidebar.open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
            </IconButton>
            <img className={classes.logo} src={headerLogo} alt='logo' />
            <Divider orientation='vertical' />
            <span>{'Gecko Nest'}</span>
            <div style={{ flex: 1 }} />
            <Avatar className={classes.avatar} name={'Corey S'} />
        </header>
    );
};
